'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var $ = _interopDefault(require('jquery'));
var isMobileUA = _interopDefault(require('../helpers/is-mobile.js'));
var utils_js = require('../helpers/utils.js');

function Video(el, options) {
  this.$video = utils_js.isJquery(el) ? el : $(el);
  this.options = options || {};

  if (this.$video.length) {
    this.init();
  }
}

Video.prototype.init = function () {
  if (isMobileUA) {
    this.initFallback();
  } else {
    this.initVideo();
  }
};

Video.prototype.initVideo = function () {
  this.$video.find('[type="video/webm"]').attr('src', this.$video.data('webm-src'));
  this.$video.find('[type="video/mp4"]').attr('src', this.$video.data('mp4-src'));
  this.$video.on('loadeddata', this.videoReady.bind(this));
  this.$video.get(0).load();
};

Video.prototype.initFallback = function () {
  var img = new Image();
  var imgClasses = ['js-is-active'].concat(this.$video[0].className.split(/\s+/));

  if (imgClasses.indexOf('inline-video') > -1) {
    imgClasses.push('inline-video--fallback');
  } else {
    imgClasses.push('background-video--fallback');
  }

  img.setAttribute('src', this.$video.attr('data-poster'));
  img.setAttribute('alt', this.$video.attr('aria-label'));
  img.className = imgClasses.join(' ');
  this.$video.after(img);
  this.$video.remove();
};

Video.prototype.videoReady = function () {
  this.$video.addClass('js-is-active');

  if ($.isFunction(this.options.onReady)) {
    this.options.onReady.call(this);
  }
};

module.exports = Video;
